/// <amd-module name="SuiteCommerce.PagePrinter.Item.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
define("SuiteCommerce.PagePrinter.Item.Model", ["require", "exports", "underscore", "Backbone", "SuiteCommerce.PagePrinter.Common.Utils", "SuiteCommerce.PagePrinter.Item.ImageHelper", "SuiteCommerce.PagePrinter.Item.Collection", "SuiteCommerce.PagePrinter.ItemDetailsLayout.Configuration"], function (require, exports, _, Backbone_1, Utils_1, Item_ImageHelper_1, Item_Collection_1, ItemDetailsLayout_Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ItemBehavior;
    (function (ItemBehavior) {
        ItemBehavior["DefaultSiteBehavior"] = "Default Site Behavior";
        ItemBehavior["AlwaysActiveForThisItem"] = "Always Active For This Item";
        ItemBehavior["DeactivateForThisItem"] = "Deactivate For This Item";
    })(ItemBehavior = exports.ItemBehavior || (exports.ItemBehavior = {}));
    var ItemModel = /** @class */ (function (_super) {
        __extends(ItemModel, _super);
        function ItemModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(ItemModel.prototype, "internalId", {
            get: function () {
                return this.get('internalid');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "sku", {
            get: function () {
                return this.get('itemid');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "name", {
            get: function () {
                return (this.get('storedisplayname2') ||
                    this.get('displayname') ||
                    this.get('itemid') ||
                    '');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "thumbnail", {
            get: function () {
                var itemImagesDetail = this.get('itemimages_detail') || {};
                var parentItem = this.parentItem;
                if (itemImagesDetail.default || itemImagesDetail.thumbnail) {
                    return Item_ImageHelper_1.ItemImageHelper.getThumbnailExisting(this, itemImagesDetail);
                }
                if (parentItem && parentItem.internalId) {
                    return parentItem.thumbnail;
                }
                return Item_ImageHelper_1.ItemImageHelper.getThumbnailFromAll(this, itemImagesDetail);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "price", {
            get: function () {
                if (Utils_1.Utils.hidePrices())
                    return;
                var onlinePriceDetails = this.get('onlinecustomerprice_detail');
                var parentItem = this.parentItem;
                if (!onlinePriceDetails && parentItem && parentItem.internalId) {
                    return parentItem.price;
                }
                return {
                    number: onlinePriceDetails
                        ? onlinePriceDetails.onlinecustomerprice
                        : null,
                    formatted: onlinePriceDetails
                        ? onlinePriceDetails.onlinecustomerprice_formatted
                        : null,
                    priceSchedule: onlinePriceDetails
                        ? this.parsePriceSchedule(onlinePriceDetails.priceschedule)
                        : null,
                    priceRange: this.matrixChildItems && this.matrixChildItems.size() > 0
                        ? this.getPriceRange(this.matrixChildItems)
                        : null,
                };
            },
            enumerable: true,
            configurable: true
        });
        ItemModel.prototype.parsePriceSchedule = function (priceSchedule) {
            if (priceSchedule === void 0) { priceSchedule = []; }
            var priceScheduleParsed = [];
            priceSchedule.forEach(function (schedule) {
                var scheduleParsed = {
                    maximumQuantity: schedule.maximumquantity
                        ? schedule.maximumquantity - 1
                        : null,
                    minimumQuantity: schedule.minimumquantity == 0 ? 1 : schedule.minimumquantity,
                    price: schedule.price,
                    priceFormatted: schedule.price_formatted,
                };
                priceScheduleParsed.push(scheduleParsed);
            });
            return priceScheduleParsed;
        };
        ItemModel.prototype.getPriceRange = function (childItems) {
            return {
                priceRangeMin: childItems.min(function (childItem) {
                    return childItem.price.number;
                }).price,
                priceRangeMax: childItems.max(function (childItem) {
                    return childItem.price.number;
                }).price,
            };
        };
        Object.defineProperty(ItemModel.prototype, "parentItem", {
            get: function () {
                return this.get('parentItem');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "matrixChildItems", {
            get: function () {
                var _this = this;
                if (this.get('matrixchilditems_detail')) {
                    var matrixChildItems_1 = new Item_Collection_1.ItemCollection();
                    this.get('matrixchilditems_detail').forEach(function (item) {
                        var childItem = new ItemModel(item);
                        childItem.set('parentItem', _this);
                        matrixChildItems_1.add(childItem);
                    });
                    return matrixChildItems_1;
                }
                return null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "isMatrixChild", {
            get: function () {
                return this.get('itemoptions_detail').matrixtype === 'child';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "parentId", {
            get: function () {
                return this.get('itemoptions_detail').parentid;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "url", {
            get: function () {
                return this.get('urlcomponent') || "product/" + this.internalId;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "rating", {
            get: function () {
                return this.get('custitem_ns_pr_rating') || 0;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "itemBehavior", {
            get: function () {
                return (this.get('custitem_ns_sc_page_printer_behavior') ||
                    ItemBehavior.DefaultSiteBehavior);
            },
            enumerable: true,
            configurable: true
        });
        ItemModel.prototype.isPrintButtonEnable = function () {
            return this.itemBehavior === ItemBehavior.AlwaysActiveForThisItem;
        };
        ItemModel.prototype.isPrintButtonDisable = function () {
            return this.itemBehavior === ItemBehavior.DeactivateForThisItem;
        };
        Object.defineProperty(ItemModel.prototype, "itemOptions", {
            get: function () {
                return this.get('itemoptions_detail');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "combinations", {
            get: function () {
                var combinations = { headers: [], body: [] };
                if (!this.isMatrixChild && this.haveItemOptions()) {
                    this.setCombinationsHeaders(combinations);
                    this.setCombinationsInfo(combinations);
                    return combinations;
                }
                return combinations;
            },
            enumerable: true,
            configurable: true
        });
        ItemModel.prototype.haveItemOptions = function () {
            return this.getItemOptionsLabel().length > 0;
        };
        ItemModel.prototype.setCombinationsHeaders = function (combinations) {
            var headers = __spreadArrays(['SKU'], this.getItemOptionsLabel());
            if (this.hasPriceRange &&
                !Utils_1.Utils.hidePrices() &&
                ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.showPrice) {
                headers.push('Price');
            }
            combinations.headers = headers;
        };
        ItemModel.prototype.getItemOptionsLabel = function () {
            if (this.itemOptions &&
                this.itemOptions.fields &&
                this.itemOptions.fields.length > 0) {
                var itemOptionsLabels_1 = [];
                this.itemOptions.fields.forEach(function (itemOption) {
                    if (itemOption.ismatrixdimension) {
                        itemOptionsLabels_1.push(itemOption.label);
                    }
                });
                return itemOptionsLabels_1;
            }
            return [];
        };
        ItemModel.prototype.setCombinationsInfo = function (combinations) {
            var _this = this;
            if (this.matrixChildItems && this.matrixChildItems.size() > 0) {
                this.matrixChildItems.forEach(function (item) {
                    combinations.body.push(_this.getItemCombination(item));
                });
            }
        };
        ItemModel.prototype.getItemCombination = function (item) {
            var itemCombination = [];
            itemCombination.push(item.sku);
            this.itemOptions.fields.forEach(function (itemOption) {
                if (itemOption.ismatrixdimension) {
                    itemCombination.push(item.get(itemOption.sourcefrom)
                        ? item.get(itemOption.sourcefrom)
                        : 'N/A');
                }
            });
            if (this.hasPriceRange && ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.showPrice) {
                itemCombination.push(item.price);
            }
            return itemCombination;
        };
        Object.defineProperty(ItemModel.prototype, "hasPriceRange", {
            get: function () {
                if (this.price &&
                    this.price.priceRange &&
                    !_.isEqual(this.price.priceRange.priceRangeMin, this.price.priceRange.priceRangeMax)) {
                    return true;
                }
                return false;
            },
            enumerable: true,
            configurable: true
        });
        return ItemModel;
    }(Backbone_1.Model));
    exports.ItemModel = ItemModel;
});
